type ProfileCompletionData =
  | {
      fullName?: string | null;
      company?: string | null;
      jobTitle?: string | null;
      phoneNumber?: string | null;
    }
  | null
  | undefined;

type ProfileCompletionField = {
  label: string;
  isComplete: (data: ProfileCompletionData) => boolean;
};

const baseCompletionFields: readonly ProfileCompletionField[] = [
  {
    label: "full name",
    isComplete: (d: ProfileCompletionData) => !!d?.fullName?.toString().trim(),
  },
  {
    label: "company",
    isComplete: (d: ProfileCompletionData) => !!d?.company?.toString().trim(),
  },
  {
    label: "job title",
    isComplete: (d: ProfileCompletionData) => !!d?.jobTitle?.toString().trim(),
  },
  {
    label: "phone number",
    isComplete: (d: ProfileCompletionData) =>
      !!d?.phoneNumber?.toString().trim(),
  },
];

export function calculateProfileCompletion(
  data: ProfileCompletionData
): number {
  const completionFields = baseCompletionFields;
  const total = completionFields.length;
  const completed = completionFields.filter((f) => f.isComplete(data)).length;
  return Math.round((completed / total) * 100);
}

export function getIncompleteProfileFields(
  data: ProfileCompletionData
): string[] {
  return baseCompletionFields
    .filter((f) => !f.isComplete(data))
    .map((f) => f.label);
}
